'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var VehicleInsured = function (_Component) {
  _inherits(VehicleInsured, _Component);
  function VehicleInsured() {
    _classCallCheck(this, VehicleInsured);
    return _possibleConstructorReturn(this, (VehicleInsured.__proto__ || Object.getPrototypeOf(VehicleInsured)).apply(this, arguments));
  }
  _createClass(VehicleInsured, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_radio.RadioYesNo, {
        name: 'vehicleInsured',
        label: 'Is the car currently insured?',
        helpText: 'This policy is designed to sit alongside an existing insurance policy on a car owned by someone else.'
      });
    }
  }]);
  return VehicleInsured;
}(_react.Component);
exports.default = VehicleInsured;